export default __webpack_public_path__ + "static/ogg-Italic-fc2c0c23ffbb4e11e45f5b1074bc5397.woff2";